/**
 * Dealer inventory sort (Dealer Profile M7/M8).
 */
import { sortVehicleListings } from "../vehicleSearch/vehicleSearchSort";
import { VEHICLE_SEARCH_SORT } from "../../constants/vehicleSearchParamsConstants";

function timestampOrZero(value) {
  if (!value) return 0;
  const ts = new Date(value).getTime();
  return Number.isNaN(ts) ? 0 : ts;
}

function isFeaturedListing(listing) {
  return Boolean(listing?.placementId || listing?.isFeatured || listing?.featuredPlacement);
}

function fairPriceRank(listing) {
  const rank = {
    below_market: 0,
    fair_price: 1,
    slightly_high: 2,
    high_price: 3,
    not_enough_data: 4,
    unknown: 5,
  };
  return rank[listing?.fairPriceLabel] ?? 5;
}

function dataCompletenessScore(listing) {
  let score = 0;
  if (listing?.primaryImageUrl) score += 1;
  if (listing?.priceCop != null) score += 1;
  if (listing?.mileageKm != null) score += 1;
  if (listing?.dealerVerified) score += 1;
  return score;
}

/** Default dealer-profile sort before user selection (M7). */
export function sortDealerInventoryListings(listings = []) {
  return getSortedDealerInventory(listings, VEHICLE_SEARCH_SORT.RECENTLY_CONFIRMED);
}

/**
 * @param {object[]} listings
 * @param {string} [sort]
 */
export function getSortedDealerInventory(listings = [], sort) {
  if (!sort || sort === VEHICLE_SEARCH_SORT.RECOMMENDED) {
    const base = sortVehicleListings(listings, sort || VEHICLE_SEARCH_SORT.RECOMMENDED);
    return [...base].sort((a, b) => {
      const featuredDelta = Number(isFeaturedListing(b)) - Number(isFeaturedListing(a));
      if (featuredDelta !== 0) return featuredDelta;
      const fairDelta = fairPriceRank(a) - fairPriceRank(b);
      if (fairDelta !== 0) return fairDelta;
      return dataCompletenessScore(b) - dataCompletenessScore(a);
    });
  }

  if (sort === VEHICLE_SEARCH_SORT.RECENTLY_CONFIRMED) {
    return [...listings].sort((a, b) => {
      const featuredDelta = Number(isFeaturedListing(b)) - Number(isFeaturedListing(a));
      if (featuredDelta !== 0) return featuredDelta;
      const confirmedDelta =
        timestampOrZero(b.lastConfirmedAt) - timestampOrZero(a.lastConfirmedAt);
      if (confirmedDelta !== 0) return confirmedDelta;
      return timestampOrZero(b.updatedAt) - timestampOrZero(a.updatedAt);
    });
  }

  return sortVehicleListings(listings, sort);
}
